export { default } from './Columns'


// WEBPACK FOOTER //
// ./src/components/Columns/index.js